export const formatBytes = bytes => {
  const value = Number(bytes);
  if (!Number.isFinite(value) || value <= 0) return "0 B";

  const units = ["B", "KB", "MB", "GB", "TB"];
  const unitIndex = Math.min(
    Math.floor(Math.log(value) / Math.log(1024)),
    units.length - 1
  );
  const formatted = value / 1024 ** unitIndex;
  // Preserve the upload UI's established precision after centralizing it.
  return `${formatted.toFixed(formatted < 10 ? 1 : 0)} ${units[unitIndex]}`;
};
